var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'wells')?_c('WellsPrice',{attrs:{"regularPrice":_vm.maybeAddTax(_vm.regularPrice),"salePrice":_vm.maybeAddTax(_vm.salePrice),"isVariable":_vm.isVariable,"showPriceRange":_vm.showPriceRange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }